// 接口失败记录
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">

      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style=" height: calc(100vh - -35px);">
          <vxe-grid
            show-overflow
            :stripe="true" border="default"
            height="100%"
            :row-config="{isHover: true}"
            ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
            @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-top"
                              @click="openEditDialog" v-if="barcodeSave">导出
                  </vxe-button>
                </div>
                <div class="fr">
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                        :data="requestParam" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent"
              >
                <vxe-form-item title="接口名称:" field="name">
                  <template v-slot>
                    <el-input v-model="formData.intfName" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="重新推送人:" field="name">
                  <template v-slot>
                    <el-input v-model="formData.repusher" size="small" clearable/>
                  </template>
                </vxe-form-item>



              </vxe-form>
            </template>
            <!-- 分页器 -->
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {indexPageMixins} from "@/mixins/tabChang"
import {initVxeTable} from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi"
import {mapGetters} from "vuex";

export default {
  name: 'code',

  mixins: [indexPageMixins],
  components: { pager},
  data() {
    return {
      barcodeSave: false,
      barcodeEdit: false,
      showEdit: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量
        intfName: "",//接口名称
        repusher:"",//重新推送人
      },
      formData: {
        intfName: "",//接口名称
        repusher:"",//重新推送人
      },

      total: 0,  // 数据总数
      vxeOption: {},
      columns: [
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        {title: '接口名称', field: 'intfName', width: 250,},
        {title: '失败报文', field: 'failMessage', width: 350,},
        {title: '请求报文', field: 'message', width: 350,},
        {title: '重新推送次数', field: 'repush', width: 120,},
        {title: '重新推送人', field: 'repusher', width: 120,},
        {title: '重新推送时间', field: 'repushTime', width: 150,},
      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.barcodeSave = this.permissions['parts_barcode_add']
    this.barcodeEdit = this.permissions['parts_barcode_edit']
  },

  mounted() {
    this.getTableData()
  },
  methods: {
    toFilterData() {
            this.searchEvent();
     },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.intfFailRecord.getTableDataUrl,
        param: this.requestParam,
        method: 'get',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
    },

  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
